// Google runs onAdd and draw after setMap returns, so the anchor is handed out only once it is on the map
export function createVertexAnchor(
	map: google.maps.Map,
	position: google.maps.LatLng,
	onReady: (anchor: HTMLDivElement) => void
) {
	const anchor = document.createElement('div');
	const overlay = new google.maps.OverlayView();
	let isReady = false;

	anchor.style.position = 'absolute';
	google.maps.OverlayView.preventMapHitsAndGesturesFrom(anchor);
	overlay.onAdd = () => overlay.getPanes().floatPane.appendChild(anchor);
	overlay.draw = () => {
		const point = overlay.getProjection().fromLatLngToDivPixel(position);

		anchor.style.left = `${point.x}px`;
		anchor.style.top = `${point.y}px`;

		if (!isReady) {
			isReady = true;
			onReady(anchor);
		}
	};
	overlay.onRemove = () => anchor.remove();
	overlay.setMap(map);

	return () => overlay.setMap(null);
}
